export default __webpack_public_path__ + "static/media/biology_test_moch_bg.20de8a5e.png";